import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useSmoothScroll } from './hooks/useSmoothScroll';

// Components
import Header from './components/Header';
import MobileMenu from './components/MobileMenu';
import Hero from './components/Hero';
import Advantages from './components/Advantages';
import About from './components/About';
import AdditionalInfo from './components/AdditionalInfo';
import Migration from './components/Migration';
import Features from './components/Features';
import Faq from './components/Faq';
import Contacts from './components/Contacts';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import { CookiePopup } from './components/Cookie/CookiePopup';

// Компонент для обработки якорных ссылок на главной
const MainContent = ({ onLearnMoreClick, scrollToSection }) => {
  const location = useLocation();

  React.useEffect(() => {
    // Обрабатываем якорные ссылки при загрузке страницы или изменении location
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');

      // Небольшая задержка чтобы дать странице загрузиться
      const timer = setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [location, scrollToSection]);

  return (
    <>
      <Hero onLearnMoreClick={onLearnMoreClick} />
      <Advantages />
      <About />
      <AdditionalInfo />
      <Migration />
      <Features />
      <Faq />
      <Contacts />
    </>
  );
};

// Компонент-обертка для главной страницы
const HomePage = ({ scrollToSection }) => {
  const handleLearnMoreClick = () => {
    scrollToSection('okompanii');
  };

  return (
    <MainContent
      onLearnMoreClick={handleLearnMoreClick}
      scrollToSection={scrollToSection}
    />
  );
};

function App() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { scrollToSection } = useSmoothScroll();

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    handleMenuClose();
  };

  return (
    <Router>
      <div className="App">
        <Header
          onMenuToggle={handleMenuToggle}
          onNavClick={handleNavClick}
          isMenuOpen={isMenuOpen}
        />

        <MobileMenu
          isOpen={isMenuOpen}
          onClose={handleMenuClose}
          onNavClick={handleNavClick}
        />

        <Routes>
          <Route path="/" element={
            <HomePage scrollToSection={scrollToSection} />
          } />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>

        <Footer />
        <CookiePopup />
      </div>
    </Router>
  );
}

export default App;